import OneMindSupportTable, { SupportFeature } from "@/components/support";

const SupportComponent = (props: SupportFeature) => {
  return <OneMindSupportTable {...props} />;
};

export default SupportComponent;
